import { ODataObject } from '../../interfaces/odata-model.interface';
import { TextModel } from '../primitive/text.model';
import { CompositeModel } from './composite.model';

export class UserModel extends CompositeModel {
    private frontId: TextModel;
    private country: TextModel;
    private salesOrg: TextModel;
    private plant: TextModel;
    private appId: TextModel;
    private userRole: TextModel;
    private personnelArea: TextModel;
    public constructor(
        frontId: string,
        country: string,
        salesOrg: string,
        plant: string,
        private readonly description: string,
        private readonly emailId: string,
        appId: string,
        userRole: string,
        personnelArea: string,
    ) {
        super('userModel');

        this.frontId = <TextModel>this.set(new TextModel('FrontId', frontId));
        this.country = <TextModel>this.set(new TextModel('Country', country));
        this.salesOrg = <TextModel>this.set(new TextModel('SalesOrg', salesOrg));
        this.plant = <TextModel>this.set(new TextModel('Plant', plant));
        this.appId = <TextModel>this.set(new TextModel('AppID', appId));
        this.userRole = <TextModel>this.set(new TextModel('UserRole', userRole));
        this.personnelArea = <TextModel>this.set(new TextModel('PersonnelArea', personnelArea));
    }

    public getFrontId(): string {
        return this.frontId.value;
    }

    public getCountry(): string {
        return this.country.value;
    }

    public getSalesOrg(): string {
        return this.salesOrg.value;
    }

    public getPlant(): string {
        return this.plant.value;
    }

    public getAppId(): string {
        return this.appId.value;
    }

    public getUserRole(): string {
        return this.userRole.value;
    }

    public getDescription(): string {
        return this.description;
    }

    public getEmailId(): string {
        return this.emailId;
    }
    public getPersonnelArea(): string {
        return this.personnelArea.value;
    }

    public static fromOData(data: ODataUserModel, appId: string): UserModel {
        return new UserModel(
            data.FrontId,
            data.Country,
            data.SalesOrg,
            data.Plant,
            data.Description,
            data.EmailId,
            appId,
            data.UserRole,
            data.PersonnelArea,
        );
    }

    public toJSON(): JsonUserModel {
        return {
            frontId: this.frontId.value,
            country: this.country.value,
            salesOrg: this.salesOrg.value,
            plant: this.plant.value,
            description: this.description,
            emailId: this.emailId,
            appId: this.appId.value,
            userRole: this.userRole.value,
            personnelArea: this.personnelArea.value,
        };
    }
}

export class UserModelFromJson extends UserModel {
    public constructor(data: JsonUserModel) {
        super(
            data.frontId,
            data.country,
            data.salesOrg,
            data.plant,
            data.description,
            data.emailId,
            data.appId,
            data.userRole,
            data.personnelArea,
        );
    }
}

export interface JsonUserModel {
    frontId: string;
    country: string;
    salesOrg: string;
    plant: string;
    description: string;
    emailId: string;
    appId: string;
    userRole: string;
    personnelArea: string;
}

export function isJsonUserModel(obj: unknown): obj is JsonUserModel {
    return (
        !!obj &&
        typeof obj === 'object' &&
        'frontId' in (obj as JsonUserModel) &&
        'country' in (obj as JsonUserModel) &&
        'salesOrg' in (obj as JsonUserModel) &&
        'plant' in (obj as JsonUserModel) &&
        'description' in (obj as JsonUserModel) &&
        'emailId' in (obj as JsonUserModel) &&
        'appId' in (obj as JsonUserModel) &&
        'userRole' in (obj as JsonUserModel) &&
        'personnelArea' in (obj as JsonUserModel)
    );
}

export interface ODataUserModel extends ODataObject {
    FrontId: string;
    Country: string;
    SalesOrg: string;
    Plant: string;
    EmailId: string;
    Description: string;
    UserRole: string;
    PersonnelArea: string;
    __metadata: {
        uri: string;
        type: 'HC_SM_NGM_AA_SRV.UserMaster';
    };
}
